import axios from "axios";

const baseURL = "https://evd-management.herokuapp.com/api/";

const axiosInstance = axios.create({
  baseURL: baseURL,
  timeout: 5000,
});

export default axiosInstance;
